var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapp"},[_c('div',{staticClass:"head-bar"},[_c('Nav')],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content flex flex-direction justify-center align-center"},[_c('img',{attrs:{"src":require("../assets/img/404.png"),"alt":""}}),_c('div',[_vm._v("您的选片链接已经失效，请联系客服获取新的连接")])])
}]

export { render, staticRenderFns }